/** And "Enum" for the "Persona" (hobby/student/educator) the user has chosen in the signup flow */
export default class UnifiedSignupPersona {
  public readonly persona;

  public static hobbyPerson = new UnifiedSignupPersona({ val: 'Hobbyist / Maker' });

  public static studentPerson = new UnifiedSignupPersona({ val: 'Student' });

  public static educatorPerson = new UnifiedSignupPersona({ val: 'Educator' });

  public static proPerson = new UnifiedSignupPersona({ val: 'Professional CAD User / Designer' });

  // Note if you update these mappings update `CadInviteRequest`
  private static mappings: Record<string, UnifiedSignupPersona> = {
    'Hobbyist / Maker': UnifiedSignupPersona.hobbyPerson,
    Student: UnifiedSignupPersona.studentPerson,
    Educator: UnifiedSignupPersona.educatorPerson,
    'Professional CAD User / Designer': UnifiedSignupPersona.proPerson,
  };

  private constructor({ val }: { val: string }) {
    this.persona = val;
  }

  public static fromString(val: string | number | boolean): UnifiedSignupPersona {
    const intent = UnifiedSignupPersona.mappings[`${val}`];
    if (!intent) throw new Error(`Could not find intent with val: '${val}'`);
    return intent;
  }

  public compareTo(rhs: UnifiedSignupPersona) {
    return this.persona === rhs.persona;
  }

  public isEduPersona() {
    return (
      this.compareTo(UnifiedSignupPersona.educatorPerson) ||
      this.compareTo(UnifiedSignupPersona.studentPerson)
    );
  }
}
